import { registerEnumType } from 'type-graphql'

/**
 * Enum representing the various states a queue job can be in.
 *
 * This enum provides an abstraction over BullMQ's job states, allowing
 * the application to work with job states without directly depending on
 * BullMQ's internal state representations.
 *
 * @see https://docs.bullmq.io/guide/jobs/job-lifecycle
 */
export enum JobStateEnum {
  /** Job is waiting to be processed */
  Waiting = 'waiting',
  /** Job is currently being processed */
  Active = 'active',
  /** Job is scheduled for later */
  Delayed = 'delayed',
  /** Job has finished successfully */
  Completed = 'completed',
  /** Job has failed (may retry) */
  Failed = 'failed',
  /** Job is paused (queue-level pause) */
  Paused = 'paused',
  /** Job is prioritized in the queue */
  Prioritized = 'prioritized',
  /** Job is waiting for child jobs to complete */
  WaitingChildren = 'waiting-children',
}

registerEnumType(JobStateEnum, {
  name: 'JobStateEnum',
  description: 'The various states a queue job can be in',
})
